import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setRedirectPath } from "../../modules/actions/authActions";
import { getCart } from "../../modules/actions/cartActions";
import { addToCart } from "../../modules/actions/cartActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { Link, withRouter } from "react-router-dom";
import { format } from "../../modules/utils"
import {getDeviceProduct, validateDeviceIMEI} from "../../modules/actions/productActions";
import { getCountries } from "../../modules/actions/countryActions";
import NotificationAlert from "react-notification-alert";
import scrollToElement from "scroll-to-element";
import {confirmAlert} from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';

class PurchaseDeviceCart extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            useType : null,
            cartType : "device",
            receiveType: "DELIVERY",
            returnType: "Mail",
            shippingFee: 0,
            quantity: 1,
            startDate : moment(),
            product: {},
            orgProduct : {},
            color : "BLACK",
            country : {},
            buy_option: "buy_device_with_data",
            promotion : null,
            showingAlert: false
        };
        this.props.getDeviceProduct(3);
        this.props.getCountries();
        this.countries = [];
        // this.setProduct();
    }

    handleClickShowAlert() {
        this.setState({
            showingAlert: true
        });

        setTimeout(() => {
            this.setState({
                showingAlert: false
            });
        }, 2000);
    }

    onStartDateChange = date => {
        this.setState({
            startDate : date
        });
    };


    onEndDateChange = date => {
        this.setState({
            endDate : date
        });
    };


    _getSubTotal = (fraction = 2) => {
        let total = 0;
        let productTotal = this.getPriceByUseType(this.state.product);
        let recurringPrice = 0;
        if (typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null){
            //recurringPrice = this.getPriceByUseType(this.state.recurringProfile);
            recurringPrice = this.state.recurringProfile.price;
        }
        total = parseFloat(productTotal) + parseFloat(recurringPrice);
        return total.toFixed(fraction);
    };

    getPriceByUseType(object){
        let price = 0;
        let useType = "USA";
        if (typeof this.state.useType !== "undefined"){
            useType = this.state.useType;
        }

        switch (useType) {
            case "USA" :
                price = object.domesticPrice;
                break;

            case "GLOBAL":
                price = object.globalPrice;
                break;

            default:
                price = object.domesticPrice;
        }

        return price;
    }

    calculateDeliveryCharges(receiveType){
        let price = 0;
        return price;
    }

    calculateReturnCharges(returnType){
        let price = 0;
        return price;
    }

    getCalculatedShipping = () => {
        let deliveryCharges = this.calculateDeliveryCharges(this.state.receiveType);
        let returnCharges = this.calculateReturnCharges(this.state.returnType);
        return parseFloat(deliveryCharges) + parseFloat(returnCharges);
    };


    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    addToCart = () => {

        if (this.state.buy_option == "buy_device"){
            this.setState({
                useType : "GLOBAL"
            })
        }

        const { product, color, country, useType, receiveType, returnType, shippingFee, quantity, cartType, promotion } = this.state;
        const sessionId = localStorage.getItem("sessionId");
        const productId = product._id;
        const subtotal = this._getSubTotal();
        const total = this._getSubTotal();

        if (typeof color === "undefined" || color === null) {
            this.setErrorMessage("Please select your color above.");
            return;
        }

        if (typeof useType === "undefined" || useType === null) {
            this.setErrorMessage("Please select a Plan.");
            return;
        }

        if (useType === "GLOBAL" && (typeof country === "undefined" || country === null)) {
            this.setErrorMessage("Please select a Country.");
            return;
        }

        if (typeof this.state.setAssocProductId === "undefined" || this.state.setAssocProductId === null) {
            this.setErrorMessage("Please select Day Pass or Data Plan.");
            return;
        }

        if (typeof this.state.recurringProfile === "undefined" || this.state.recurringProfile === null || typeof this.state.associatedProduct === "undefined" || this.state.associatedProduct === null) {
            let assocProductName = "Data Plan";
            if(this.state.setAssocProductId === "5c76913ff7b6460023607206") {
                assocProductName = "Day Pass";
            }
            this.setErrorMessage("Please select a plan for " + assocProductName);
            return;
        }

        let startDate = "";
        let endDate = "";

        if (typeof this.state.startDate !== "undefined") {
            startDate = format(this.state.startDate);
        }

        if (typeof this.state.startDate !== "undefined" && typeof this.state.endDate !== "undefined") {
            startDate = format(this.state.startDate);
            endDate = this.endDate;
        }

        let recurring_profile_id = null;

        if (typeof this.state.recurringProfile !== "undefined" && this.state.recurringProfile !== null){
            recurring_profile_id = this.state.recurringProfile._id;
        }

        let associated_product_id = null

        if (typeof this.state.associatedProduct !== "undefined" && this.state.associatedProduct !== null){
            associated_product_id = this.state.associatedProduct._id;
        }

        const buy_option = this.state.buy_option;

        let payload = {
            cartType,
            startDate,
            endDate,
            useType,
            receiveType,
            returnType,
            quantity,
            sessionId,
            total,
            subtotal,
            shippingFee,
            productId,
            product,
            color,
            country,
            promotion,
            recurring_profile : recurring_profile_id,
            associated_product : associated_product_id,
            buy_option : buy_option
        };

        this.performCartAction(payload);
    };

    performCartAction(payload){
        const { auth } = this.props;
        const promotion = this.state.promotion;
        if (auth.isAuthenticated) {
            this.props
                .addToCart(payload)
                .then(data => {
                    if (data.status) {
                        if(promotion) {
                            this.context.router.history.replace({
                                pathname: "/checkout",
                                params: {
                                    product: this.state.product,
                                    cart: payload,
                                    associatedProduct: this.state.associatedProduct,
                                    recurringProfile: this.state.recurringProfile,
                                    //promotion: promotion,
                                    discount: this.getDiscountCode(promotion)
                                }
                            });
                        }
                        else {
                            this.context.router.history.push({
                                pathname: "/checkout",
                                params: {
                                    product: this.state.product,
                                    cart: payload,
                                    associatedProduct: this.state.associatedProduct,
                                    recurringProfile: this.state.recurringProfile
                                }
                            });
                        }
                    } else {
                        this.showMessage(data.message);
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.showMessage(error.response.data.message);
                });
        } else {
            this.props.setRedirectPath("/checkout", payload);
            this.context.router.history.push({
                pathname : "/login",
                params : {
                    product : payload.product,
                    cart : payload,
                    associatedProduct:  this.state.associatedProduct,
                    recurringProfile : this.state.recurringProfile,
                    promotion: promotion,
                    discount: this.getDiscountCode(promotion)
                }
            });
        }
    }

    componentDidMount() {
        if (typeof this.props.location.state !== 'undefined' && typeof this.props.location.state.anchor !== 'undefined') {
            scrollToElement("#" + this.props.location.state.anchor, { offset: 0 });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(typeof this.state.country === "undefined" || this.state.country === null || Object.keys(this.state.country).length === 0) {
            console.log("nextProps", nextProps);
            if (typeof nextProps.products !== "undefined" && nextProps.products.length > 0) {
                let product = nextProps.products[0];
                /*this.setState({
                    product: {...product},
                    orgProduct: {...product}
                })*/
                this.state.product = product;
                this.state.orgProduct = product;

                /*const promotion = this.context.router.route.match.params.promotion;
                if (promotion && this.getDiscountCode(promotion) != null) {*/
                if (typeof nextProps.location.state !== "undefined" &&
                    typeof nextProps.location.state.promotion !== "undefined" &&
                    typeof nextProps.location.state.buy_option !== "undefined" &&
                    typeof nextProps.location.state.useType !== "undefined") {

                    const promotion = nextProps.location.state.promotion;
                    if (promotion && this.getDiscountCode(promotion) != null) {
                        this.state.product = product;
                        this.state.orgProduct = product;
                        this.state.promotion = nextProps.location.state.promotion;
                        this.state.buy_option = nextProps.location.state.buy_option;
                        this.state.useType = nextProps.location.state.useType;
                        if (typeof nextProps.location.state.color !== "undefined") {
                            this.setColor(nextProps.location.state.color);
                        }
                        this.state.setAssocProductId = product.associated_products[1]._id;
                        var recurringProfile = product.associated_products[1].recurring_profiles[4]; //50GB
                        if (promotion == "79") {
                            recurringProfile = product.associated_products[1].recurring_profiles[0]; //3G
                        }
                        else if (promotion == "105") {
                            recurringProfile = product.associated_products[1].recurring_profiles[2]; //20G
                        }
                        this.state.recurringProfile = recurringProfile;
                        this.state.associatedProduct = product.associated_products[1];
                        this.state.country = null;

                        /*
                        if(typeof this.props.cart.cart !== 'undefined' && typeof this.props.cart.cart.product !== 'undefined') {
                            this.props.cart.cart.product.image = "/images/mightywifi-cloud-" + nextProps.location.state.color.toLowerCase() + ".png";
                            this.props.cart.cart.product.color = nextProps.location.state.color;
                            this.props.cart.cart.color = nextProps.location.state.color;
                        }
                        console.log(this.props.cart.cart);
                        */

                        this.addToCart();
                    }
                }
            }

            if (typeof nextProps.countries !== "undefined" && nextProps.countries.length > 0) {
                this.countries = nextProps.countries;
            }

            if (typeof nextProps.location.state !== "undefined" &&
                typeof nextProps.location.state.useType !== "undefined" &&
                typeof nextProps.location.state.country !== "undefined" &&
                typeof nextProps.location.state.associatedProduct !== "undefined" &&
                typeof nextProps.location.state.recurringProfile !== "undefined") {

                this.state.useType = nextProps.location.state.useType;
                this.state.country = nextProps.location.state.country;
                this.state.setAssocProductId = nextProps.location.state.associatedProduct._id;
                this.state.associatedProduct = nextProps.location.state.associatedProduct;
                if (nextProps.location.state.useType === "GLOBAL") {
                    this.state.product.associated_products = nextProps.location.state.country.associated_products;
                }
                this.state.recurringProfile = nextProps.location.state.recurringProfile;
            }
        }
    }

    setBuyOption(buyOption){
        this.setState({
            buy_option : buyOption
        })
    }

    setErrorMessage(errorMessage){
        this.setState({
            errorMessage: errorMessage
        })
    }

    setUseType(useType){
        if(useType !== this.state.useType) {
            this.setState({
                useType: useType
            })
            this.setState({
                recurringProfile: null,
                associatedProduct: null,
                country: null
            });
            this.state.product.associated_products = this.state.orgProduct.associated_products;
        }
    }

    setColor(color) {
        if(color !== this.state.color) {
            this.setState({
                color: color
            })
            //this.state.product.image = "/images/mightywifi-cloud-" + color.toLowerCase() + ".png";
            this.state.product.color = color;
        }
    }

    setColorWithConfirm(color) {
        if(color !== this.state.color) {
            /*if (true) {
                confirmAlert({
                    title: 'Sold Out Item',
                    message: 'This MightyWifi CLOUD is currently sold out here, so we are redirecting you to our Amazon Shop. Is that okay?',
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => window.location = "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp"
                        },
                        {
                            label: 'No'
                        }
                    ]
                });
            }*/
            /*if (color === 'WHITE') {
                confirmAlert({
                    title: 'Sold Out Item',
                    message: 'Thank you for your interest in our Mightywifi Cloud White. We are currently sold out of White color but Black color is still available. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => window.location = "https://www.amazon.com/dp/B07NDGFV71?ref=myi_title_dp"
                        },
                        {
                            label: 'No'
                        }
                    ]
                });
            }
            else if (color === 'BLUE') {
                confirmAlert({
                    title: 'Sold Out Item',
                    //message: 'This MightyWifi CLOUD is currently sold out here, so we are redirecting you to our Amazon Shop. Is that okay?',
                    message: 'Thank you for your interest in our Mightywifi Cloud Blue. We are currently sold out of Blue color but Black color is still available. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
                    buttons: [
                        {
                            label: 'Yes',
                            //onClick: () => window.location = color === "WHITE" ? "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp" : "https://www.amazon.com/dp/B088BBQJJY?ref=myi_title_dp"
                            //onClick: () => window.location = "https://www.amazon.com/dp/B088BBQJJY?ref=myi_title_dp"
                            onClick: () => window.location = "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp"
                        },
                        {
                            label: 'No'
                        }
                    ]
                });
            }
            else */if (color === 'BLACK') {
                /*confirmAlert({
                    title: 'Sold Out Item',
                    message: 'Thank you for your interest in our Mightywifi Cloud Black. We are currently sold out of Black color. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => window.location = "https://www.amazon.com/dp/B07NDGFV71?ref=myi_title_dp"
                        },
                        {
                            label: 'No'
                        }
                    ]
                });*/
            }
            else {
                /*confirmAlert({
                    title: 'Pre-order Only',
                    message: 'This MightyWifi CLOUD is for preorder only. All preorders will be fulfilled Starting 6/22/20. Are you interested in ordering?',
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => {
                                this.setState({
                                    color: color
                                })
                                this.state.product.image = "/images/mightywifi-cloud-" + color.toLowerCase() + ".png";
                                this.state.product.color = color;
                            }
                        },
                        {
                            label: 'No'
                        }
                    ]
                });*/
                this.setState({
                    color: color
                })
                //this.state.product.image = "/images/mightywifi-cloud-" + color.toLowerCase() + ".png";
                this.state.product.color = color;
            }
        }
    }

    getCountryById(id){
        var country = this.countries.find((country) => {
            return id === country._id
        });
        return country;
    }

    reset(){
        this.setState({
            //buy_option : null,
            buy_option : "buy_device_with_data",
            errorMessage : null,
            color : null,
            useType : null,
            setAssocProductId : null,
            recurringProfile : null,
            associatedProduct : null,
            //startDate : ""
            startDate : moment(),
            product : this.state.product,
            country : null
        })
    }

    _onChange = event => {
        const field = event.target.name;
        const value = event.target.value;

        this.setState({ [field]: value.trim() });

        if(field == 'country') {
            let useType = null;
            let country = this.getCountryById(value);
            if(country != null && typeof country.type !== "undefined" && country.type != null) {
                useType = country.type;
            }
            if(country != null && typeof country.associated_products !== "undefined" && country.associated_products != null && country.associated_products.length > 0) {
                this.state.product.associated_products = country.associated_products;
            }
            else {
                this.state.product.associated_products = this.state.orgProduct.associated_products;
            }
            this.setState({
                useType: useType,
                country: country,
                setAssocProductId : null,
                recurringProfile : null,
                associatedProduct : null
            });
        }
    }

    setAssociatedProduct(productId){
        /*this.setState({
            setAssocProductId : productId
        })*/
        if(productId !== this.state.setAssocProductId) {
            this.setState({
                setAssocProductId: productId
            })
            this.setState({
                recurringProfile : null,
                associatedProduct : null,
                startDate : moment()
            });
        }
    }

    getDiscountCode(promotion) {
        if(promotion == "120") {
            return "Amazon50GB";
        }
        else if(promotion == "105") {
            return "Amazon20GB";
        }
        else if(promotion == "79") {
            return "Amazon3GB";
        }
        else {
            return null;
        }
    }

    onRecurringProfileSelect(associatedProduct,recurringProfile){
        this.setState({
            recurringProfile : recurringProfile,
            associatedProduct : associatedProduct
        });
    }

    render() {
        const { product } = this.state;
        let p_country_id = '';
        if (this.state.country) {
            p_country_id = this.state.country._id;
        }

        // Checking stock
        /*
        const hasStock = true;
        const hasStock = this.state.color !== null && (this.state.color !== 'BLUE' && this.state.color !== 'BLACK') ? false : true;
        const hasStock = this.state.color !== null && (this.state.color !== 'BLUE') ? false : true;
        */
        //const hasStock = this.state.color !== null && this.state.color !== 'BLACK' ? false : true;
        //const hasStock = false;
        const hasStock = true;

        return(
            <section className="BodyContainer">
                <div className="container">
                    <div className="row position-relative">

                        <NotificationAlert ref="notify"/>

                        <div className="col-md-5 services_img_bg">
                            <div className="col-lg-12">
                                <div className="m-product-title">
                                    MightyWifi <span className="Serif">Buy</span>
                                </div>
                            </div>
                            {/*<img style={{display: this.state.color === null || this.state.color === 'WHITE' ? "block": "none"}} src="/images/mightywifi-cloud-white.png" alt="Mightywifi US and Global hotspot wifi device" />
                            <img style={{display: this.state.color === 'BLACK' ? "block": "none"}} src="/images/mightywifi-cloud-black.png" alt="Mightywifi US and Global hotspot wifi device" />
                            <img style={{display: this.state.color === 'BLUE' ? "block": "none"}} src="/images/mightywifi-cloud-blue.png" alt="Mightywifi US and Global hotspot wifi device" />*/}
                            {/* V3 Device */}
                            <img style={{display: "block"}} src="/images/mightywifi-cloud-v3.png" alt="Mightywifi US and Global hotspot wifi device" />
                            <div style={{clear:"both"}}></div>

                            {/*<a href="/images/mightywifi-cloud-white.png" className="device-link-thumb" data-lightbox="image-1">
                                <img src="/images/mightywifi-cloud-white.png" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device front image" />
                            </a>
                            <a href="/images/mightywifi-cloud-black.png" className="device-link-thumb" data-lightbox="image-2">
                                <img src="/images/mightywifi-cloud-black.png" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device side image" />
                            </a>
                            <a href="/images/mightywifi-cloud-blue.png" className="device-link-thumb" data-lightbox="image-3">
                                <img src="/images/mightywifi-cloud-blue.png" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device with case image" />
                            </a>*/}

                            {/* <a href="/images/mighty5.jpg" data-lightbox="image-4">
                                <img src="/images/mighty5.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device gaming image" />
                            </a>
                            <a href="/images/mighty7.jpg" data-lightbox="image-5">
                                <img src="/images/mighty7.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device travel image" />
                            </a>
                            <a href="/images/mighty_wall-charger2.jpg" className="device-link-thumb" data-lightbox="image-6">
                                <img src="/images/mighty_wall-charger2.jpg" className="device-thumb" style={{marginTop:"10px"}} alt="Mightywifi US and Global hotspot wifi device wall charger image" />
                            </a> */}
                        </div>


                        <div className="col-md-7 services_clip pt-d-5p">
                            <div className="services_bg_pad">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="text-left device_boxes mt-3 rounded p-4">
                                            <div id="GlobalPoint" className="services_content mt-3">

                                                <p className="mb-0 mt-2">
                                                    {/*{ product.description }*/}
                                                    The MightyWifi mobile hotspot allows users to instantly and securely connect up to 10 devices optimally to a local cellular network via its cloud SIM technology. The MightyWifi works in over 150 countries at 4G LTE speeds. We offer a range of plans to best match your needs.
                                                </p>

                                                <div style={{clear:"both",height:"15px"}}></div>
                                                <h3 className="SansSerif bold600">${ this.getPriceByUseType(product) }</h3>
                                                <div style={{clear:"both",height:"15px"}}></div>

                                                <div className="ShortDc" style={{whiteSpace:"pre-line"}}>{ product.shortDescription }</div>

                                                {/*
                                                    <div style={{clear:"both",height:"15px"}}></div>

                                                    <a onClick={ () => this.setBuyOption("buy_device")} className={`btn btn-outline-white` + ((this.state.buy_option && this.state.buy_option == 'buy_device') ?  `btn btn-outline-white active` : "")}>
                                                        BUY DEVICE ONLY
                                                    </a>

                                                    &nbsp;or&nbsp;

                                                    <a  onClick={ () => this.setBuyOption("buy_device_with_data")} className={`btn btn-outline-white` + ((this.state.buy_option && this.state.buy_option == 'buy_device_with_data') ?  `btn btn-outline-white active` : "")}>
                                                        BUY DEVICE WITH DATA PLAN
                                                    </a>
                                                */}

                                                {
                                                    (!hasStock) ? (
                                                        <div>
                                                            <div style={{clear:"both",height:"30px"}}></div>
                                                            {/*<strong>Thank you for your interest in Mightywifi, we are currently out of stock. Please revisit us soon.</strong><br/>*/}
                                                            <span style={{color:"#cc0000",fontWeight:"bold"}}>OUT OF STOCK. NEW MODEL AVAILABLE IN JULY.</span><br/>
                                                            <p className="mb-1"><small>Please leave us your contact information at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a>, we will contact you once we have availability again.</small></p>
                                                        </div>
                                                    ) : null
                                                }

                                                {
                                                    (hasStock && typeof this.state.buy_option !== "undefined" && this.state.buy_option !== null && this.state.buy_option == "buy_device_with_data") ? (
                                                        <div>
                                                            {/* Color Select*/}
                                                            {/*<div style={{clear:"both",height:"30px"}}></div>
                                                            <div className="ColorSelect">
                                                                <div style={{clear:"both",height:"15px"}}></div>
                                                                <strong>1. Choose Your Color</strong>
                                                                <div style={{clear:"both",height:"15px"}}></div>
                                                                <a onClick={ () => this.setColorWithConfirm('WHITE') } className={`btn btn-white btn-color mr-15` + ((this.state.color && this.state.color == 'WHITE') ?  ` active` : "")}><span className="color-box white"></span> White</a>
                                                                <a className={`btn btn-white btn-color mr-15 btn-disabled`}><span className="color-box black"></span> White</a>
                                                                <a onClick={ () => this.setColorWithConfirm('BLACK') } className={`btn btn-white btn-color mr-15` + ((this.state.color && this.state.color == 'BLACK') ?  ` active` : "")}><span className="color-box black"></span> Black</a>
                                                                <a className={`btn btn-white btn-color mr-15 btn-disabled`}><span className="color-box black"></span> Black</a>
                                                                <a onClick={ () => this.setColorWithConfirm('BLUE') } className={`btn btn-white btn-color` + ((this.state.color && this.state.color == 'BLUE') ?  ` active` : "")}><span className="color-box blue"></span> Blue</a>
                                                                <a className={`btn btn-white btn-color mr-15 btn-disabled`}><span className="color-box black"></span> Blue</a>
                                                            </div>*/}
                                                            {/*<div style={{clear:"both",height:"15px"}}></div>
                                                            <div className="notice red-text bold600">* Please select color</div>*/}

                                                            {
                                                                (typeof this.state.color !== "undefined" && this.state.color !== null && this.state.color !== "") ? (

                                                                    <div>

                                                                        <div style={{clear:"both",height:"30px"}}></div>

                                                                        {/*<strong>Are you travelling within the US or Internationally?</strong><br/>*/}
                                                                        {/*<strong>2. Choose Your Plan</strong><br/>*/}
                                                                        <strong>Choose Your Plan</strong><br/>
                                                                        <p className="mb-1"><small>Device will not operate without an active data plan for the region.</small></p>

                                                                        <div style={{clear:"both",height:"15px"}}></div>

                                                                        {/*<a onClick={() => this.setUseType("USA")} className={`btn btn-white mr-15` + ((this.state.useType && this.state.useType == 'USA') ?  ` active` : "")}>US Only</a>
                                                                        <a onClick={() => this.setUseType("GLOBAL")} className={`btn btn-white` + ((this.state.useType && this.state.useType == 'GLOBAL') ?  ` active` : "")}>Global (US excluded)</a>*/}

                                                                        {/*{
                                                                            (typeof this.countries !== "undefined" && this.countries !== null && typeof this.state.useType !== "undefined" && this.state.useType == "GLOBAL") ? (

                                                                                <div>

                                                                                    <div style={{clear:"both",height:"15px"}}></div>
                                                                                    <div className="row">
                                                                                        <div className="col-lg-6">
                                                                                            <select name="country" className="form-control max-width-200-px" id="country" onChange={this._onChange}>
                                                                                                <option value="">-- Select a Country or a Region --</option>
                                                                                                {
                                                                                                    this.countries.map(
                                                                                                        (country) => (
                                                                                                            <option value={country._id} selected={country._id == p_country_id}>{country.name}</option>
                                                                                                        )
                                                                                                    )
                                                                                                }
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            ) : null
                                                                        }*/}

                                                                        <div className="row">
                                                                            <div className="col-lg-8">
                                                                                <select name="country" className="form-control max-width-200-px" id="country" onChange={this._onChange}>
                                                                                    <option value="">-- Select a Country or a Region --</option>
                                                                                    {
                                                                                        this.countries.map(
                                                                                            (country) => (
                                                                                                <option value={country._id} selected={country._id == p_country_id}>{country.name}</option>
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                ) : null
                                                            }

                                                        </div>
                                                    ) : null
                                                }

                                                <div id="mask" onClick="document.location='#';"></div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            (typeof this.state.country !== "undefined" && this.state.country !== null && this.state.country.description !== null && this.state.country.description !== '') ? (

                                <div className="col-lg-12">{this.state.country.description}</div>

                            ) : null
                        }

                        <div style={{clear:"both",height:"15px"}}></div>

                        <div className="col-md-12">

                            {
                                (hasStock && typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ? (
                                    <div>
                                        {/*<div style={{clear:"both",height:"50px"}}></div>*/}
                                        <div style={{clear:"both",height:"30px"}}></div>
                                        {/*<div className="line"></div>*/}
                                        <div style={{clear:"both",height:"15px"}}></div>
                                        <strong>Day Pass or Data Plan?</strong>
                                        <div style={{clear:"both",height:"15px"}}></div>
                                    </div>
                                ) : null
                            }

                            {
                                (hasStock && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ?
                                    product.associated_products.map(
                                        associated_product => (
                                            <span>
                                            <a className={`btn btn-white mr-15` + ((this.state.setAssocProductId && this.state.setAssocProductId !== null && this.state.setAssocProductId == associated_product._id) ?  ` active` : "")} onClick={() => this.setAssociatedProduct(associated_product._id)}>{associated_product.name}{((this.state.useType == "USA" && associated_product.type == "day_pass") ?  ` *` : "")}<br/><span style={{fontSize: "1.0rem",  whiteSpace: "pre-line"}}>{associated_product.shortDescription}</span></a>
                                            </span>
                                        )
                                    )
                                    : null
                            }
                            {/*<a href="#" className="btn btn-outline-white">DAY PASS</a>*/}
                            {/*&nbsp;&nbsp;*/}
                            {/*<a href="#" className="btn btn-outline-white">DATA PACKAGE</a>*/}

                            <div style={{clear:"both",height:"30px"}}></div>


                            {/*{
                                (typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null) ?
                                    product.associated_products.map(
                                        associated_product => (

                                            <div style={{fontSize:"12px"}}>
                                                <strong><i className="mdi mdi-help-circle"></i>{associated_product.name}</strong>
                                                : {associated_product.shortDescription}
                                                <br/>
                                                <br/>
                                            </div>

                                        )
                                    )
                                    : null
                            }*/}

                            {
                                (hasStock && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && this.state.useType == "USA") ?
                                    (

                                        <div style={{fontSize:"18px"}}>
                                            <strong className="uppercase">Day Pass</strong>
                                            : Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                                            <br/>
                                            * The Day Pass becomes active upon activation and expires at midnight each day according to U.S. Pacific Time (GMT-5), rather than being valid for a full 24 hours from the time of activation.
                                            <br/>
                                            * For a limited time period, UNLIMITED US multiple day passes are available for US travelers.
                                            <br/>
                                            <br/>
                                            <strong className="uppercase">Data Plan</strong>
                                            : Data plans offer a set amount of data for 30 days starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                                            <br/>
                                            <br/>
                                        </div>
                                    )
                                    : null

                            }

                            {
                                (hasStock && typeof product.associated_products !== "undefined" && product.associated_products !== null && typeof this.state.useType !== "undefined" && this.state.useType !== null && this.state.useType == "GLOBAL" && typeof this.state.country !== "undefined" && this.state.country !== null) ?
                                    (

                                        <div style={{fontSize:"18px"}}>
                                            <strong className="uppercase">Day Pass</strong>
                                            : Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                                            <br/>
                                            * The Day Pass becomes active upon activation and expires at midnight each day according to U.S. Pacific Time (GMT-5), rather than being valid for a full 24 hours from the time of activation.
                                            <br/>
                                            <br/>
                                            <strong className="uppercase">Data Plan</strong>
                                            : Data plans offer a set amount of data for 30 days or 180 days depending on your data size starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                                            <br/>
                                            <br/>
                                        </div>
                                    )
                                    : null

                            }

                            <div style={{clear:"both",height:"15px"}}></div>

                            {
                                (hasStock && typeof product.associated_products !== "undefined" && typeof this.state.useType !== "undefined" && this.state.useType !== null && (this.state.useType !== "GLOBAL" || (typeof this.state.country !== "undefined" && this.state.country !== null))) ?
                                    product.associated_products.map(
                                        associated_product => (

                                            (this.state.setAssocProductId !== null && associated_product._id == this.state.setAssocProductId) ? (
                                                <div className="assoc_product">

                                                    {/* <strong>{associated_product.name}</strong> */}
                                                    {/* <div style={{clear:"both",height:"15px"}}></div> */}

                                                    {
                                                        (typeof associated_product.recurring_profiles !== "undefined" && associated_product.recurring_profiles.length > 0) ? (
                                                            associated_product.recurring_profiles.map(
                                                                recurring_profile => (
                                                                    (recurring_profile.status === 1 && recurring_profile.price > 0) ? (
                                                                        <button onClick={() => this.onRecurringProfileSelect(associated_product,recurring_profile)} className={`btn btn-white mr-15 mb-3 product-btn` + ((this.state.recurringProfile && this.state.recurringProfile !== null && this.state.recurringProfile._id == recurring_profile._id) ?  `btn btn-white mr-15 mb-3 active product-btn` : "")}>{recurring_profile.name} <strong>${recurring_profile.price}</strong></button>
                                                                    ) : null
                                                                )
                                                            )
                                                        ) : null
                                                    }

                                                    <div style={{clear:"both",height:"15px"}}></div>

                                                    {
                                                        ((typeof associated_product.options !== "undefined" && associated_product.options.length > 0) ?  (
                                                            associated_product.options.map(
                                                                option => (

                                                                    (option.type == "date") ? (
                                                                        <div className="row col">
                                                                            <div className="form-group mt-3">
                                                                                <strong>Start Date</strong>
                                                                            </div>
                                                                            <div className="col-lg-2">
                                                                                <div className="form-group mt-3">
                                                                                    <DatePicker
                                                                                        className="form-control data-field"
                                                                                        selected={this.state.startDate}
                                                                                        minDate={moment()}
                                                                                        onChange={this.onStartDateChange}
                                                                                        id="startDate"
                                                                                        placeholderText="Start Date"
                                                                                        onChangeRaw={event => {
                                                                                            event.preventDefault();
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : null
                                                                )
                                                            )
                                                        ) : null)
                                                    }

                                                    <div style={{clear:"both",height:"15px"}}></div>
                                                </div>
                                            ) : null
                                        )
                                    )
                                    : null
                            }

                            {
                                (typeof this.state.errorMessage !== "undefined" && this.state.errorMessage !== null) ? (
                                    <span>
                                        <div style={{clear:"both",height:"30px"}}></div>
                                        <span style={{color:"#da0905"}}>{this.state.errorMessage}</span>
                                    </span>
                                ) : null
                            }

                            {
                                (hasStock && typeof this.state.buy_option !== "undefined" && this.state.buy_option == "buy_device" && typeof this.state.useType !== "undefined" && this.state.useType !== null) ? (
                                    <div className="row">
                                        <div className="col-md-12"><div style={{clear:"both",height:"30px"}}></div></div>
                                        <div className="col-md-8">
                                            <h2 className="mb-0 SansSerif bold100">
                                                YOUR TOTAL IS <span className="bold700">${this._getSubTotal()}</span>
                                            </h2>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <a className="btn btn-orange mr-15" onClick={this.addToCart}>BUY NOW</a>
                                            {/*<a href="#" className="btn btn-outline-white">RESET</a>*/}
                                            <a className="btn btn-outline-white" onClick={() => this.reset()}>RESET</a>
                                        </div>
                                    </div>
                                ) : null
                            }

                            {
                                (hasStock && typeof this.state.buy_option !== "undefined" && this.state.buy_option == "buy_device_with_data" && typeof this.state.useType !== "undefined" && this.state.useType !== null) ? (
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/* <div style={{clear:"both",height:"50px"}}></div> */}
                                            {/* <div className="line"></div> */}
                                            <div style={{clear:"both",height:"40px"}}></div>
                                        </div>
                                        <div className="col-md-8">
                                            <h2 className="mb-0 SansSerif bold100">
                                                YOUR TOTAL IS <span className="bold700">${this._getSubTotal()}</span>
                                            </h2>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <a className="btn btn-orange mr-15" onClick={this.addToCart}>BUY NOW</a>
                                            <a className="btn btn-white" onClick={() => this.reset()}>RESET</a>
                                        </div>
                                    </div>
                                ) : null
                            }
                            <div style={{ clear: "both", height: "50px" }} />
                        </div>

                        <div className="desktop-view" style={{ clear: "both", height: "150px" }} />
                        <div className="mobile-view" style={{ clear: "both", height: "0px" }} />

                        <div className="col-md-12">
                            <div class="line"></div>
                            <h3 class="sub no-margin bold100 mb-3 SansSerif text-center">Limited Time Promotion</h3>
                            <div className="row">
                                {/*<div className="col-md-6">*/}
                                <div className="col-md-4">
                                    <div className="promotion mb-4 text-center promoitem focus p-5">
                                        <p class="promo-label">LIMITED TIME</p>
                                        <p className="promo-title SansSerif">MightyWifi CLOUD <br/><span className="bold100">w/ 50GB US data &<br/>1GB Global data</span></p>
                                        {/* <p className="promo-dc">
                            <span className="bold600">U.S.</span>: Free Unlimited U.S. 50GB 4G/LTE Data for 30Days<br/>
                            <span className="bold600 uppercase">Global</span>: Free Limited Global 3GB 4G/LTE Data for 30Days
                            </p> */}
                                        <p className="promo-price">
                                            {/*<span className="promo-discount-price mr-1">$210</span> <span className="promo-org-price mr-2 point-blue">$159</span>*/}
                                            {/*<span className="promo-discount-price mr-1">$210</span> <span className="promo-org-price mr-2 point-blue">$165.90</span>*/}
                                            {/*<span className="promo-discount-price mr-1">$210</span> <span className="promo-org-price mr-2 point-blue">$169</span>*/}
                                            <span className="promo-discount-price mr-1">$210</span> <span className="promo-org-price mr-2 point-blue">$120</span>
                                        </p>
                                        {/* <span>
                                <Link className="btn" to={{
                                    pathname: "/buy/device",
                                    state : {
                                        promotion : '159',
                                        buy_option : 'buy_device_with_data',
                                        useType : 'USA',
                                        color : 'WHITE'
                                    }
                                  }}>
                                    Buy Now
                                  </Link>
                            </span> */}<span><a href="/sale" className="btn">See more</a></span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="promotion mb-4 text-center promoitem p-5">
                                        <p className="promo-label">LIMITED TIME</p>
                                        <p className="promo-title SansSerif">MightyWifi CLOUD <br/><span
                                            className="bold100">w/ 20GB US data OR<br/>1GB Global data</span></p>
                                        <p className="promo-price">
                                            <span className="promo-discount-price mr-1">$190</span> <span className="promo-org-price mr-2 point-blue">$105</span>
                                        </p>
                                        <span><a href="/sale" className="btn">See more</a></span>
                                    </div>
                                </div>
                                {/*<div className="col-md-6">*/}
                                <div className="col-md-4">
                                    <div className="promotion mb-4 text-center promoitem p-5">
                                        <p class="promo-label">LIMITED TIME</p>
                                        <p className="promo-title SansSerif">MightyWifi CLOUD <br/><span className="bold100"> w/ 3GB US data OR<br/>1GB Global data</span></p>
                                        {/* <p className="promo-dc">
                            <span className="bold600">U.S.</span>: Free Unlimited U.S. 3GB 4G/LTE Data for 30Days<br/>
                            <span className="bold600 uppercase">Global</span>: Free Limited Global 3GB 4G/LTE Data for 30Days
                            </p> */}
                                        <p className="promo-price">
                                            {/*<span className="promo-discount-price mr-11px">$160</span> <span className="promo-org-price mr-2 point-blue">$139</span>*/}
                                            {/*<span className="promo-discount-price mr-11px">$160</span> <span className="promo-org-price mr-2 point-blue">$126.40</span>*/}
                                            {/*<span className="promo-discount-price mr-11px">$160</span> <span className="promo-org-price mr-2 point-blue">$129</span>*/}
                                            {/*<span className="promo-discount-price mr-11px">$170</span> <span className="promo-org-price mr-2 point-blue">$99</span>*/}
                                            <span className="promo-discount-price mr-11px">$170</span> <span className="promo-org-price mr-2 point-blue">$79</span>
                                        </p>
                                        {/* <span>
                                <Link className="btn" to={{
                                    pathname: "/buy/device",
                                    state : {
                                        promotion : '139',
                                        buy_option : 'buy_device_with_data',
                                        useType : 'USA',
                                        color : 'WHITE'
                                    }
                                }}>
                                    Buy Now
                                  </Link>
                            </span> */}<span><a href="/sale" className="btn">See more</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

        )
    }
}


PurchaseDeviceCart.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart,
        products: state.product.products,
        countries: state.country.countries
    };
}

export default withRouter(connect(
    mapStateToProps,
    { getDeviceProduct, getCountries, addToCart, addFlashMessage, setRedirectPath, getCart }
)(PurchaseDeviceCart));



// WEBPACK FOOTER //
// ./src/pages/purchaseDevice/PurchaseDeviceCart.js